// phone-model-selector.js
// Powers the brand → model phone picker on PDPs.
// Reads data from window.PHONE_MODELS (populated by phone-model-data.liquid).

(function() {
  'use strict';

  function init(container) {
    if (!container || container.dataset.initialized === 'true') return;
    container.dataset.initialized = 'true';

    var caseType = container.dataset.caseType;
    if (!caseType || !window.PHONE_MODELS || !window.PHONE_MODELS[caseType]) {
      console.warn('[PhoneSelector] No data for case type:', caseType);
      return;
    }

    var allModels = window.PHONE_MODELS[caseType];
    var brandSelect = container.querySelector('[data-phone-brand-select]');
    var modelField = container.querySelector('[data-phone-model-field]');
    var searchInput = container.querySelector('[data-phone-model-search]');
    var dropdown = container.querySelector('[data-phone-model-dropdown]');
    var selectedBox = container.querySelector('[data-phone-model-selected]');
    var selectedText = container.querySelector('[data-selected-text]');
    var clearBtn = container.querySelector('[data-clear-selection]');
    var brandInput = container.querySelector('[data-phone-brand-input]');
    var modelInput = container.querySelector('[data-phone-model-input]');
    var skuInput = container.querySelector('[data-phone-sku-input]');

    // Brand order: Apple → Samsung → then by model count
    var brandCounts = {};
    allModels.forEach(function(m) {
      brandCounts[m.brand] = (brandCounts[m.brand] || 0) + 1;
    });
    var brands = Object.keys(brandCounts).sort(function(a, b) {
      if (a === 'Apple') return -1;
      if (b === 'Apple') return 1;
      if (a === 'Samsung') return -1;
      if (b === 'Samsung') return 1;
      return brandCounts[b] - brandCounts[a];
    });

    brands.forEach(function(brand) {
      var opt = document.createElement('option');
      opt.value = brand;
      opt.textContent = brand;
      brandSelect.appendChild(opt);
    });

    var filteredModels = [];

    function renderDropdown(query) {
      query = (query || '').toLowerCase().trim();
      var results = filteredModels.filter(function(m) {
        if (!query) return true;
        return m.model.toLowerCase().indexOf(query) !== -1;
      });

      dropdown.innerHTML = '';

      if (results.length === 0) {
        var empty = document.createElement('div');
        empty.className = 'phone-selector__dropdown-empty';
        empty.textContent = 'No models match. Try a different search.';
        dropdown.appendChild(empty);
        dropdown.hidden = false;
        return;
      }

      results.forEach(function(m) {
        var item = document.createElement('div');
        item.className = 'phone-selector__dropdown-item';
        item.textContent = m.model;
        item.addEventListener('mousedown', function(e) {
          e.preventDefault();
          selectModel(m);
        });
        dropdown.appendChild(item);
      });

      dropdown.hidden = false;
    }

    function selectModel(model) {
      brandInput.value = model.brand;
      modelInput.value = model.model;
      skuInput.value = model.sku;

      searchInput.hidden = true;
      dropdown.hidden = true;
      selectedBox.hidden = false;
      selectedText.textContent = model.model;

      container.dispatchEvent(new CustomEvent('phone-model:selected', {
        bubbles: true,
        detail: { brand: model.brand, model: model.model, sku: model.sku }
      }));
    }

    function clearSelection() {
      brandInput.value = '';
      modelInput.value = '';
      skuInput.value = '';
      selectedBox.hidden = true;
      searchInput.hidden = false;
      searchInput.value = '';
      searchInput.focus();
      renderDropdown('');
    }

    brandSelect.addEventListener('change', function() {
      var currentBrand = brandSelect.value;
      clearSelection();
      brandInput.value = currentBrand;

      if (!currentBrand) {
        modelField.hidden = true;
        filteredModels = [];
        return;
      }

      filteredModels = allModels.filter(function(m) { return m.brand === currentBrand; });
      modelField.hidden = false;
      searchInput.focus();
      renderDropdown('');
    });

function toggleMobileDock(hide) {
      var dock = document.querySelector('mobile-dock');
      if (dock) dock.style.display = hide ? 'none' : '';
    }

    searchInput.addEventListener('input', function() {
      renderDropdown(searchInput.value);
    });

    searchInput.addEventListener('focus', function() {
      toggleMobileDock(true);
      if (filteredModels.length > 0) renderDropdown(searchInput.value);
    });

    searchInput.addEventListener('blur', function() {
      toggleMobileDock(false);
      setTimeout(function() { dropdown.hidden = true; }, 200);
    });

    brandSelect.addEventListener('focus', function() {
      toggleMobileDock(true);
    });

    brandSelect.addEventListener('blur', function() {
      toggleMobileDock(false);
    });

    clearBtn.addEventListener('click', clearSelection);

    // Pre-select from URL parameter — e.g. ?model=iphone-15-pro
    try {
      var params = new URLSearchParams(window.location.search);
      var modelParam = params.get('model');
      if (modelParam) {
        var slug = modelParam.toLowerCase().replace(/-/g, ' ');
        var match = allModels.find(function(m) {
          return m.model.toLowerCase() === slug;
        });
        if (match) {
          brandSelect.value = match.brand;
          brandSelect.dispatchEvent(new Event('change'));
          setTimeout(function() { selectModel(match); }, 100);
        }
      }
    } catch (e) {
      console.warn('[PhoneSelector] URL preselect failed:', e);
    }
  }

  window.PhoneModelSelector = {
    getSelection: function() {
      var brandInput = document.querySelector('[data-phone-brand-input]');
      var modelInput = document.querySelector('[data-phone-model-input]');
      var skuInput = document.querySelector('[data-phone-sku-input]');
      return {
        brand: brandInput ? brandInput.value : '',
        model: modelInput ? modelInput.value : '',
        sku: skuInput ? skuInput.value : ''
      };
    },
    getProperties: function() {
      var s = this.getSelection();
      var props = {};
      if (s.brand) props['Phone Brand'] = s.brand;
      if (s.model) props['Phone Model'] = s.model;
      if (s.sku) props['_Model SKU'] = s.sku;
      return props;
    }
  };

  function initAll() {
    var containers = document.querySelectorAll('[data-phone-selector]');
    for (var i = 0; i < containers.length; i++) {
      init(containers[i]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
